import { render, staticRenderFns } from "./crudusuario.vue?vue&type=template&id=284791ad&"
import script from "./crudusuario.vue?vue&type=script&lang=js&"
export * from "./crudusuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports